//react
import { useEffect, useState, useRef } from "react";
import { Link, useNavigate, useLocation } from "react-router-dom";

//css
import styled from "styled-components";

// img
// 임시 이미지
import A530Jpg from "../../../assets/img/picture/a530.jpg";

// responsive
import { M, MMinus, T } from "../../../utils/MT";

// componet
import ProductBox from "../../../component/content/ProductBox";
import Pagination from "../../../component/pagination/Pagination";
import BasicBtn from "../../../component/button/BasicBtn";

// testData
import { ProductData } from "../../../Data";

export default function WishList() {
    //페이지 이동
    const navigate = useNavigate();
    const goProduct = () => {
        navigate(`/product`);
    };
    // 관련제품 리스트 data
    const wishDataList = [];

    return (
        <Warp>
            <WishTitle>Wish list</WishTitle>
            {/* 위시리스트 */}
            {/* 한페이지에 6개씩 노출 */}
            {ProductData.length > 0 ? (
                <WishListWrap>
                    {ProductData.map((item, index) => {
                        return (
                            <ProductBox
                                isWish={true}
                                key={"wishDataList" + index}
                                id={item.id}
                                productImg={item.productImg}
                                itemName={item.itemName}
                                desc={item.desc}
                                isDiscount={item.isDiscount}
                                orginPrice={item.orginPrice}
                                percent={item.percent}
                                price={item.price}
                                i={item.id}
                            />
                        );
                    })}
                </WishListWrap>
            ) : (
                // empty
                <EmptyWrap>
                    <EmptyText>위시리스트가 비어있습니다.</EmptyText>
                </EmptyWrap>
            )}

            {/* 페이지네이션 */}
            {
                // 6개 이상일시 보이게 해주세요!
                ProductData.length > 5 && (
                    // wishDataList.length > 6 &&
                    <PageNationWrap>
                        <Pagination />
                    </PageNationWrap>
                )
            }
        </Warp>
    );
}

const Warp = styled.div`
    position: relative;
    width: calc(100vw * (1060 / 1920));
    margin: 0 auto;

    padding-top: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));

        padding-top: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};

        padding-top: ${M(30)};
    }
`;
const WishTitle = styled.h3`
    font-family: "Pop-R";
    font-size: calc(100vw * (50 / 1920));
    text-align: center;

    margin-bottom: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (50 / 1300));

        margin-bottom: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(20)};

        margin-bottom: ${M(30)};
    }
`;

const WishListWrap = styled.ul`
    width: calc(100vw * (1060 / 1920));
    margin: 0 auto calc(100vw * (60 / 1920));

    display: flex;
    flex-wrap: wrap;

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (1060 / 1300));
        margin: 0 auto calc(100vw * (60 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};

        margin: 0 auto ${M(40)};
    }
`;

const EmptyWrap = styled.div`
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;

    width: calc(100vw * (200 / 1920));
    margin: calc(100vw * (280 / 1920)) auto calc(100vw * (400 / 1920));

    min-height: calc(100vh - 100vw * (500 / 1920));

    @media screen and (max-width: 1300px) {
        width: calc(100vw * (200 / 1300));
        margin: calc(100vw * (280 / 1300)) auto calc(100vw * (400 / 1300));

        min-height: calc(100vh - 100vw * (500 / 1300));
    }

    @media screen and (max-width: 900px) {
        width: ${M(378)};
        margin: ${M(378)} auto ${M(378)};

        min-height: ${MMinus(378)};
    }
`;

const EmptyText = styled.p`
    font-size: calc(100vw * (15 / 1920));
    color: #ddd;

    margin-bottom: calc(100vw * (50 / 1920));

    @media screen and (max-width: 1300px) {
        font-size: calc(100vw * (15 / 1300));

        margin-bottom: calc(100vw * (50 / 1300));
    }

    @media screen and (max-width: 900px) {
        font-size: ${M(14)};

        margin-bottom: ${M(395)};
    }
`;

const PageNationWrap = styled.div`
    text-align: center;

    margin-bottom: calc(100vw * (200 / 1920));

    @media screen and (max-width: 1300px) {
        margin-bottom: calc(100vw * (200 / 1300));
    }

    @media screen and (max-width: 900px) {
        margin-bottom: ${M(108)};
    }
`;
